import { FamilyTreeActionFn, StartExportAction } from '../types';

export const startExportAction: FamilyTreeActionFn<StartExportAction> = (
  state
) => {
  return {
    ...state,
    isExporting: true,
  };
};
